<div class="form-group gw-relative gw-h-[72px] {{ class }}">
  <div class="gw-flex gw-flex-col gw-h-[72px]">
    <label
      *ngIf="label"
      [attr.for]="effectiveInputId"
      class="gw-form-label gw-h-[16px]"
    >
      {{ label }}
      <span *ngIf="required" class="gw-text-status-negative">*</span>
    </label>

    <div
      class="gw-input-group gw-flex gw-flex-col gw-items-start gw-w-full"
      [tuiDropdown]="dropdownTpl"
      [(tuiDropdownOpen)]="open"
      tuiDropdownAlign="left"
      tuiDropdownLimitWidth="fixed"
      (tuiActiveZoneChange)="onActiveZoneChange($event)"
    >
      <tui-textfield
        tuiChevron
        tuiTextfieldSize="m"
        class="gw-w-full"
        [tuiTextfieldCleaner]="false"
      >
        <input
          tuiTextfield
          role="combobox"
          [id]="effectiveInputId"
          [attr.name]="effectiveInputId"
          class="select-async-input hover:gw-bg-background-neutral-1-hover"
          [placeholder]="placeholder"
          autocomplete="off"
          aria-autocomplete="list"
          aria-haspopup="listbox"
          [attr.aria-expanded]="open"
          [attr.aria-controls]="listboxId"
          [attr.aria-activedescendant]="activeOptionId"
          [attr.aria-required]="required || null"
          [attr.aria-disabled]="disabled || null"
          [disabled]="disabled"
          [ngModel]="searchTerm"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onSearchTermChange($event)"
          (focus)="onFocus($event)"
          (keydown)="onKeyDown($event)"
        />

        <button
          *ngIf="searchTerm && !disabled"
          type="button"
          class="gw-absolute gw-h-[44px] gw-text-[12px] gw-right-[40px] gw-top-1/2 gw--translate-y-1/2 gw-text-text-secondary hover:gw-text-text-primary gw-transition-colors gw-duration-200 gw-cursor-pointer focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus focus:gw-ring-offset-1"
          [attr.aria-label]="t('common.selectAsync.clear')"
          (mousedown)="$event.preventDefault()"
          (click)="clearValue($event)"
        >
          <i class="fa-solid fa-x" aria-hidden="true"></i>
        </button>
      </tui-textfield>

      <error-message *ngIf="control" [control]="control"></error-message>
    </div>
  </div>
</div>

<ng-template #dropdownTpl>
  <div class="gatewee-select-async-panel">
    <div
      *ngIf="
        state.loading && !state.items.length && !state.error;
        else loadedBlock
      "
      role="status"
      aria-live="polite"
      class="gw-px-3 gw-py-3 gw-text-sm gw-text-text-secondary"
    >
      {{ t('common.selectAsync.loading') }}
    </div>

    <ng-template #loadedBlock>
      <div
        *ngIf="state.error && !state.items.length"
        role="status"
        aria-live="polite"
        class="gw-flex gw-flex-col gw-gap-2 gw-px-3 gw-py-3"
      >
        <p class="gw-m-0 gw-text-sm gw-text-text-negative">
          {{ t('common.selectAsync.error') }}
        </p>
        <button
          type="button"
          class="gw-self-start gw-cursor-pointer gw-border-0 gw-bg-transparent gw-p-0 gw-text-sm gw-text-text-link hover:gw-underline"
          (mousedown)="$event.preventDefault()"
          (click)="retry()"
        >
          {{ t('common.selectAsync.retry') }}
        </button>
      </div>

      <div
        *ngIf="
          !state.loading &&
          !state.error &&
          !state.items.length &&
          searchTerm.length < minSearchLength
        "
        role="status"
        aria-live="polite"
        class="gw-px-3 gw-py-3 gw-text-sm gw-text-text-secondary"
      >
        {{ t('common.selectAsync.typeToSearch') }}
      </div>

      <div
        *ngIf="
          !state.loading &&
          !state.error &&
          !state.items.length &&
          searchTerm.length >= minSearchLength
        "
        role="status"
        aria-live="polite"
        class="gw-px-3 gw-py-3 gw-text-sm gw-text-text-secondary"
      >
        {{ t('common.selectAsync.empty') }}
      </div>

      <ul
        *ngIf="state.items.length"
        #listRef
        role="listbox"
        [id]="listboxId"
        [attr.aria-label]="label || placeholder || null"
        class="gw-m-0 gw-flex gw-max-h-[320px] gw-flex-col gw-overflow-y-auto gw-list-none gw-p-0"
        (scroll)="onListScroll()"
      >
        <li
          *ngFor="let item of state.items; let i = index; trackBy: trackByValue"
          role="option"
          [id]="optionId(i)"
          [attr.aria-selected]="isOptionSelected(item)"
          class="gw-cursor-pointer gw-px-3 gw-py-2 gw-text-sm hover:gw-bg-background-neutral-1-hover"
          [class.gw-bg-background-neutral-1-hover]="i === activeIndex"
          (mousedown)="$event.preventDefault()"
          (mouseenter)="onOptionMouseEnter(i)"
          (click)="selectItem(item)"
        >
          <span>{{ item?.label }}</span>
        </li>

        <li
          *ngIf="state.loadingMore"
          role="status"
          aria-live="polite"
          class="gw-px-3 gw-py-2 gw-text-sm gw-text-text-secondary"
        >
          {{ t('common.selectAsync.loadingMore') }}
        </li>
      </ul>
    </ng-template>
  </div>
</ng-template>
